import customSelect from 'custom-select';

function init() {
  customSelect('select');
}

export default {
  init,
};
